import GaugeCircle from './GaugeCircle';

export default GaugeCircle;
